import { palette } from "./colors";
import { size } from "./size";

/** Icon sizing, stroke, and color tokens */
export const iconSize = size.icon;

export const iconStroke = {
  thin: 1,
  regular: 1.5,
  bold: 2,
} as const;

export const iconColor = {
  primary: palette.icon.primary,
  secondary: palette.icon.secondary,
  disabled: palette.icon.disabled,
  onDark: palette.icon.onDark,
  onBrand: palette.icon.onBrand,
  inactive: palette.icon.inactive,
  inactiveOnDark: palette.icon.inactiveOnDark,
} as const;

export type TIconSize = typeof iconSize;
export type TIconStroke = typeof iconStroke;
export type TIconColor = typeof iconColor;
